import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const DeepLinkPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const retailerId = searchParams.get('r') || '';
  const orderId = searchParams.get('o') || '';
  const invoiceId = searchParams.get('d') || '';

  useEffect(() => {
    if (!retailerId) {
      console.error('Invalid deep link');
      return navigate('/');
    }
    if (orderId) {
      return navigate(`/documents/${retailerId}/orders/${orderId}`);
    } else if (invoiceId) {
      return navigate(`/documents/${retailerId}/invoices/${invoiceId}`);
    } else {
      navigate('/');
    }
  }, []);

  return <></>;
};

export default DeepLinkPage;
